import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DxChartModule, DxSelectBoxModule} from 'devextreme-angular';
import { TransportInterventionsMetricsChartsComponent } from './transport-interventions-metrics-charts.component';
import {DxoValueAxisModule} from 'devextreme-angular/ui/nested';



@NgModule({
  declarations: [TransportInterventionsMetricsChartsComponent],
  imports: [
    CommonModule,
    DxChartModule,
    DxSelectBoxModule,
    DxoValueAxisModule
  ],
  exports: [TransportInterventionsMetricsChartsComponent]
})
export class TransportInterventionsMetricsChartsModule { }
